import { Icon } from "ui";
import { ReactNode } from "react";
import { SpacingStyle } from "core/styles/paddingMarginStyle";
import { ASSETS } from "../../../apps/vite-app/src/consts/_assets";
import { ButtonStyle, ButtonLink, SpinIcon } from "./_buttonStyle";

export enum ButtonVariant {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  DANGER = "danger",
  TEXT = "text",
  OUTLINED = "outlined",
  OUTLINED_2 = "outlined_2",
  SECONDARY_OUTLINED = "secondaryOutlined",
  PRIMARY_LIGHT = "primaryLight",
  TEXT_SECONDARY = "textSecondary",
}

export type TButtonVariant = `${ButtonVariant}`;
export type ButtonSize = "s" | "m" | "l" | "xl" | "auto";

export type ButtonProps = {
  variant: TButtonVariant;
  width?: string;
  height?: string;
  size?: ButtonSize;
  children?: ReactNode;
  rounded?: boolean;
  shape?: "rounded" | "square";
  isLoading?: boolean;
  withProgress?: boolean;
  lineHeight?: string;
  weight?: number;
  onClick?: React.MouseEventHandler;
  onBlur?: (e: React.FocusEvent<HTMLButtonElement>) => void;
  whiteSpace?: string;
  fontSize?: number;
  to?: string;
  isLink?: boolean;
  disabled?: boolean;
  icon?: string | ReactNode;
  color?: string;
  "data-testid"?: string;
  target?: string;
  iconSpace?: number;
} & SpacingStyle &
  React.ButtonHTMLAttributes<HTMLButtonElement>;

function Button(props: ButtonProps) {
  const {
    onClick,
    width,
    size,
    rounded,
    variant,
    isLoading,
    children,
    fontSize,
    withProgress,
    to,
    isLink,
    disabled,
    icon,
    color,
    type = "button",
    "data-testid": dataTestId,
    iconSpace = 4,
    ...rest
  } = props;

  const generateSpinIcon = (variant: any) => {
    switch (variant) {
      case "primaryLight":
      case "secondary":
      case "text":
      case "ghost":
        return ASSETS.general.loaderblack;
      default:
        return ASSETS.general.loaderWhite;
    }
  };

  const clickHandler = (e: any) => {
    // @ts-expect-error TS(2349): This expression is not callable.
    onClick(e);
    setTimeout(() => {
      e.target.blur();
    }, 150);
  };

  const contextMenuHandler = (e: any) => {
    setTimeout(() => {
      e.target.blur();
    }, 150);
  };

  const ButtonElement = (
    <ButtonStyle
      data-testid={dataTestId}
      onClick={clickHandler}
      onContextMenu={contextMenuHandler}
      {...props}
      type={type}>
      {withProgress && isLoading ? (
        <SpinIcon src={generateSpinIcon(variant)} size={size} />
      ) : (
        <>
          {icon && typeof icon === "string" ? <Icon src={icon} size={16} mr={4} /> : icon}
          {icon && typeof icon !== "string" && <div style={{ marginRight: `${iconSpace}px` }} />}
          {children}
        </>
      )}
    </ButtonStyle>
  );

  if (isLink) {
    return (
      <ButtonLink to={to!} {...rest}>
        {ButtonElement}
      </ButtonLink>
    );
  }

  return ButtonElement;
}

Button.defaultProps = {
  width: null,
  height: null,
  size: "l",
  rounded: false,
  variant: "primary",
  isLoading: false,
  withProgress: false,
  onClick: () => {},
  whiteSpace: "normal",
};

export default Button;
